// Stub: expo-document-picker — uses browser <input type="file"> on web/desktop
export const getDocumentAsync = (options = {}) =>
  new Promise((resolve) => {
    const input   = document.createElement('input');
    input.type    = 'file';
    input.accept  = options.type ? (Array.isArray(options.type) ? options.type.join(',') : options.type) : '*/*';
    input.multiple = options.multiple ?? false;
    input.onchange = () => {
      const files = Array.from(input.files || []);
      if (!files.length) { resolve({ canceled: true, assets: [] }); return; }
      const assets = files.map((file) => ({
        uri: URL.createObjectURL(file),
        name: file.name,
        size: file.size,
        mimeType: file.type,
        lastModified: file.lastModified,
      }));
      resolve({ canceled: false, assets, output: assets });
    };
    input.oncancel = () => resolve({ canceled: true, assets: [] });
    input.click();
  });

export const pickSingle = (options = {}) =>
  getDocumentAsync({ ...options, multiple: false })
    .then((result) => result.canceled ? Promise.reject(new Error('canceled')) : result.assets[0]);

export default { getDocumentAsync, pickSingle };
